import { NodeSpec } from 'prosemirror-model';

export const NODE_NAME = 'math_display';

export const getSchema = (): NodeSpec => {
  return {
    group: 'block math',
    content: 'text*', // important!
    atom: true, // important!
    code: true, // important!
    toDOM: () => ['math-display', { class: 'math-node mt-16' }, 0],
    parseDOM: [
      {
        tag: 'math-display', // important!
      },
    ],
  };
};
